import { AiMarkdown } from "../components/ai/AiMarkdown";
import { AkilDataList } from "../components/ai/AkilListRow";
import AkilSaveDkButton from "../components/ai/AkilSaveDkButton";

export function formatAkilReply(data) {
    const text =
        data.yanit_metni ||
        data.mesaj ||
        data.yorum ||
        data.yanit ||
        data.metin ||
        (data.success === false ? data.error || data.detail : "İşlem tamamlandı.");

    const liste = data.liste || (data.sonuc && data.sonuc.items);

    return (
        <div>
            <AiMarkdown text={text} />
            <AkilDataList items={liste} />
            {data.kaydet_action ? (
                <AkilSaveDkButton kaydetAction={data.kaydet_action} />
            ) : null}
        </div>
    );
}

export const AKIL_WIDGET_QUICK_PROMPTS = [
    "Bugün neye öncelik vereyim?",
    "Eksik ne?",
    "Müvekkile eksik evrak WhatsApp yaz",
    "Tahkime geçemez miyiz, neden?",
    "Günlük brifing özeti",
    "Toplu eksik evraklı dosyalar",
    "Workflow pilot — başvuruya al",
    "Mesaj şablonu performansı",
];

export const AKIL_CHAT_GREETING =
    "Merhaba, ben **Akıl**. Eksik evrak (7 zorunlu kural), günlük brifing, mesaj taslağı, tahkim/workflow ve dosya bağlamını anlarım. Dosya detayındayken *eksik ne?* veya *müvekkile eksik evrak yaz* deneyin.";
